module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_risoto.35dba896.png";